import Box from "@mui/material/Box";

// Petit séparateur floral doré, discret.
export default function Flourish({ width = 220 }: { width?: number }) {
  return (
    <Box aria-hidden sx={{ display: "flex", justifyContent: "center", my: "16px" }}>
      <svg width={width} height="16" viewBox="0 0 220 16" fill="none">
        <path d="M4 8 H92" stroke="#BFA06A" strokeWidth="1" />
        <path d="M128 8 H216" stroke="#BFA06A" strokeWidth="1" />
        <path d="M100 8 q5 -7 10 0 q-5 7 -10 0Z" fill="#BFA06A" />
        <circle cx="110" cy="8" r="2.4" fill="#BFA06A" />
        <circle cx="95" cy="8" r="1.5" fill="#BFA06A" />
        <circle cx="125" cy="8" r="1.5" fill="#BFA06A" />
      </svg>
    </Box>
  );
}
